import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a35598ae&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a35598ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35598ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a35598ae')) {
      api.createRecord('a35598ae', component.options)
    } else {
      api.reload('a35598ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a35598ae&scoped=true&", function () {
      api.rerender('a35598ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/goodRelevance/index.vue"
export default component.exports